import { z } from "zod";
import type {
  ShipmentCalculatorBaseResponse,
  ShipmentCalculatorAirDoubleWeightResponse,
} from "@/schemas/ship";
import { useCreate } from "./useCreate";

const CreateShipmentCalculationBaseSchema = z.object({
  origin_country: z.literal("CN"),
  destination_country: z.enum(["NG", "GH"]),
});

const CreateShipmentCalculationAirFieldSchema = z.object({
  channel: z.literal("Air"),
  model: z.enum(["Normal", "Special"]),
  weight_1: z.number(),
});

export const CreateShipmentCalculationAirSingleSchema = CreateShipmentCalculationBaseSchema.extend(
  CreateShipmentCalculationAirFieldSchema.shape,
);

const CreateShipmentCalculationAirDoubleOnlyFieldsSchema = z.object({
  weight_2: z.number(),
});

export const CreateShipmentCalculationAirDoubleSchema =
  CreateShipmentCalculationAirSingleSchema.extend(
    CreateShipmentCalculationAirDoubleOnlyFieldsSchema.shape,
  );

const CreateShipmentCalculationSeaCbmFieldSchema = z.object({
  channel: z.literal("Sea"),
  model: z.literal("Sea"),
  cbm: z.number(),
});

export const CreateShipmentCalculationSeaCbmSchema = CreateShipmentCalculationBaseSchema.extend(
  CreateShipmentCalculationSeaCbmFieldSchema.shape,
);

const CreateShipmentCalculationSeaDimensionFieldsSchema = z.object({
  channel: z.literal("Sea"),
  model: z.literal("Sea"),
  length: z.number(),
  width: z.number(),
  height: z.number(),
  quantity : z.number().optional(),
});

export const CreateShipmentCalculationSeaDimensionSchema =
  CreateShipmentCalculationBaseSchema.extend(
    CreateShipmentCalculationSeaDimensionFieldsSchema.shape,
  );

export type CreateShipmentCalculationPayload =
  | z.infer<typeof CreateShipmentCalculationAirSingleSchema>
  | z.infer<typeof CreateShipmentCalculationAirDoubleSchema>
  | z.infer<typeof CreateShipmentCalculationSeaCbmSchema>
  | z.infer<typeof CreateShipmentCalculationSeaDimensionSchema>;

export type CreateShipmentCalculationResponse =
  | ShipmentCalculatorBaseResponse
  | ShipmentCalculatorAirDoubleWeightResponse;

export function useCreateShipmentCalculation({
  onSuccess,
}: {
  onSuccess?: (data: CreateShipmentCalculationResponse) => void;
}) {
  return useCreate<
    CreateShipmentCalculationPayload,
    CreateShipmentCalculationResponse
  >({
    endpoint: "/ship/pricing/calculator",
    queryKeys: ["ship", "pricing", "calculator"],
    name: "shipment calculation",
  })({ onSuccess });
}

